import {
    GET_DASHBOARD_FAULTED_SITES_CHART,
    GET_DASHBOARD_FAULTED_SITES_CHART_SUCCESS,
    GET_DASHBOARD_FAULTED_SITES_CHART_FAIL,
  } from 'actions/dashboard';
  
  const initialState = {
    isLoading: false,
    dashboardFaultedSites: {},
  };

  const dashboardFaultedSitesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case GET_DASHBOARD_FAULTED_SITES_CHART: {
        return { ...state, isLoading: true };
      }
        
      case GET_DASHBOARD_FAULTED_SITES_CHART_SUCCESS: {
        return {
          ...state,
          isLoading: false,
          dashboardFaultedSites: payload,
        };
      }
  
      case GET_DASHBOARD_FAULTED_SITES_CHART_FAIL: {
        return { ...state, isLoading: false };
      }
  
      default:
        return { ...state };
    }
  };
  export default dashboardFaultedSitesReducer;
